import { Component, Input, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { TranslatePipe } from '../../../translate/translate.pipe';
import { TranslateService } from '../../../translate/translate.service';
import { PagamentiDTO } from '../../models/pagamento-dto';

@Component({
  selector: 'lib-lista-pagamenti',
  templateUrl: './lista-pagamenti.component.html',
  styleUrls: ['./lista-pagamenti.component.css']
})
export class ListaPagamentiComponent implements OnInit {

  @Input()
  pagamenti: Array<PagamentiDTO>;
  loadingLinguage: boolean;
  constructor(private translateService: TranslateService, private translatePipe: TranslatePipe) { }

  ngOnInit(): void {
    this.translatePipe.transform('');
    this.translateService.traduzioniLib$
      .pipe(
        tap(_ => _ ? this.loadingLinguage = true : null)
      )
      .subscribe()
  }

}
